import { GET_USER_CONTACT_API, USER_CONTACT_API } from '../commons/constants/apis';
import { ResponseTypes } from '../types/response';
import { PromotionSubmitFormTypes } from '../types/response/promotion';
import { UserContactResponseTypes } from '../types/response/userContact';
import axios from './axios';

export const saveCustomerContactInfo = async (
  dataRequest: PromotionSubmitFormTypes
): Promise<boolean> => {
  const { data }: ResponseTypes<boolean> = await axios.post(`${USER_CONTACT_API}`, dataRequest);
  return data;
};

export const getUserContactByCode = async (
  childItemCode: string,
  alias: string,
  language: string
): Promise<any> => {
  try {
    const { data }: ResponseTypes<UserContactResponseTypes> = await axios.get(
      `${GET_USER_CONTACT_API}/${childItemCode}`,
      { params: { alias }, headers: { language } }
    );

    return data;
  } catch (e) {
    return { notFound: true };
  }
};
